import { createAction } from 'redux-actions'

const SET_SHOP_INFO = 'SET_SHOP_INFO'
const setShopInfo = createAction(SET_SHOP_INFO)

function selectedShop(state = {}, { type, payload }) {
  switch (type) {
    case SET_SHOP_INFO:
      return payload
    default:
      return state
  }
}

const SHOW_EXTRAS_UPDATE_MODAL = 'SHOW_EXTRAS_UPDATE_MODAL'

const setShowExtrasModal = createAction(SHOW_EXTRAS_UPDATE_MODAL)

function extrasModalVisible(
  state = { visibility: false, message: null },
  { type, payload }
) {
  switch (type) {
    case SHOW_EXTRAS_UPDATE_MODAL:
      return payload
    default:
      return state
  }
}

const SET_GUESTS = 'SET_GUESTS'

const setGuestsList = createAction(SET_GUESTS)

function guestsList(state = [], { type, payload }) {
  switch (type) {
    case SET_GUESTS:
      return payload
    default:
      return state
  }
}

export {
  setShopInfo,
  selectedShop,
  extrasModalVisible,
  setShowExtrasModal,
  setGuestsList,
  guestsList,
}
